import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../Constant';

const Popup = ({
  message,
  title = "Notification",
  onClose,
  type = "success",
  onGuestContinue,
  product_id,   // ✅ now available
  addsize,      // ✅ now available
  quantity      // ✅ now available
}) => {

  const navigate = useNavigate();
  const [popupTitle, setPopupTitle] = useState(title);
  const [popupMessage, setPopupMessage] = useState(message);

  const borderColor =
    type === "success"
      ? '#096e09'
      : type === "loginOrGuest"
      ? '#227070'
      : 'red';

const handleGuestContinue = async () => {
  const storedGuestId = localStorage.getItem('guest_id');

  if (storedGuestId) {
    // guest_id exists, no need to call API or add to cart again
    localStorage.setItem('userId', storedGuestId);
    localStorage.setItem('userName', 'Guest');
    localStorage.setItem('hasShownPopup', '');
    setPopupTitle('Guest Login');
    setPopupMessage('Welcome back, Guest!');
    
    // Pass existing guest_id to callback if any
    if (onGuestContinue) onGuestContinue(storedGuestId);

    setTimeout(() => {
      onClose();
      navigate('/');
    }, 1000);
  } else {
    // No guest_id, call API to create one and add to cart
    try {
      const response = await fetch(api + 'get_guest_id', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          guest_id: "", // empty since new guest
          product_id,
          size: addsize,
          quantity
        })
      });

      const data = await response.json();

      console.log("Guest API Response:", data);

      if (response.ok && (data.success === true || data.success === "true")) {
        localStorage.setItem('guest_id', data.guest_id.toString());
        localStorage.setItem('userId', data.guest_id.toString());
        localStorage.setItem('userName', 'Guest');
        localStorage.setItem('hasShownPopup', '');
        setPopupTitle('Guest Login');
        setPopupMessage(data.message || 'You are logged in as a Guest.');

        if (onGuestContinue) onGuestContinue(data.guest_id);

        setTimeout(() => {
          onClose();
          navigate('/');
        }, 1000);
      } else {
        setPopupTitle('Error');
        setPopupMessage(data.message || 'Unable to login as Guest');
      }
    } catch (error) {
      console.error("Guest login error:", error);
      setPopupTitle('Error');
      setPopupMessage('Something went wrong during guest login.');
    }
  }
};


  return (
    <div className='popup-overlay'>
      <div className='popuperor' style={{ border: `1px solid ${borderColor}` }}>
        <h3 style={{ color: borderColor }}>{popupTitle}</h3>
        <p>{popupMessage}</p>
{type === "loginOrGuest" ? (
  <div className="popup-buttons">
    <button
      className="login-btn"
      onClick={() => navigate('/Login-Page', {
        state: { product_id, size: addsize, quantity }
      })}
    >
      Login
    </button>
    <button
      className="guest-btn"
      onClick={handleGuestContinue}
    >
      proceed as Guest
    </button>
  </div>
) : (
  <button className="close-btn" onClick={onClose}>Close</button>
)}

      </div>
    </div>
  );
};

export default Popup;
